import { useLocation } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';

export const useIsBalanceSheet = () => {
  const { pathname } = useLocation();
  return pathname.indexOf(ROUTES.BALANCE_SHEET) !== -1;
};
